// extracted by mini-css-extract-plugin
export default {"container":"container-SSkCjtmh","table":"table-ROkRteBL"};